"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * SimulationStringConverter.
 *
 * @author BPo
 */


var SimulationBigNumberConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(SimulationBigNumberConverter, _DataObjectConverter_);

  function SimulationBigNumberConverter() {
    _classCallCheck(this, SimulationBigNumberConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(SimulationBigNumberConverter).apply(this, arguments));
  }

  return SimulationBigNumberConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.SimulationBigNumberConverter = SimulationBigNumberConverter;